export const dishes = [
    '3723',
    '3813',
    '3926',
    '3996',
    '3838',
    '58',
    '3502',
    '3689',
    '3702',
    '668',
    '122',
    '3472',
    '3947',
    '4905',
    '4894',
    '4220',
];
